import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = {
  class: "nav nav-tabs mb-4",
  id: "serviceTab",
  role: "tablist"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  class: "tab-content",
  id: "serviceTabContent"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "details-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "details-tab",
  tabindex: "0"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_11 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_13 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_14 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_15 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_16 = { class: "d-flex align-items-center gap-2" }
const _hoisted_17 = {
  key: 0,
  class: "material-symbols-outlined fs-24 text-primary"
}
const _hoisted_18 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_19 = { class: "col-lg-6 col-md-6 mb-4 d-flex align-items-center" }
const _hoisted_20 = { class: "form-check form-switch mt-2" }
const _hoisted_21 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_22 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_23 = { class: "form-label text-dark fs-14 fw-medium d-flex justify-content-between align-items-center" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_28 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_29 = { class: "fw-semibold fs-14" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "row g-2" }
const _hoisted_32 = { class: "col-sm-2" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "col-sm-2" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "col-sm-2" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { class: "col-sm-2" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "col-sm-2" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "col-sm-2" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "col-sm-12 mt-2 d-flex align-items-end" }
const _hoisted_45 = { class: "form-check form-switch mb-1" }
const _hoisted_46 = ["id", "onUpdate:modelValue"]
const _hoisted_47 = ["for"]
const _hoisted_48 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_51 = {
  class: "tab-pane fade",
  id: "tutorials-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "tutorials-tab",
  tabindex: "0"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_54 = { class: "mb-0 fs-16 text-dark" }
const _hoisted_55 = {
  key: 0,
  class: "table-responsive mb-4"
}
const _hoisted_56 = { class: "table align-middle" }
const _hoisted_57 = { class: "fw-medium" }
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "alert alert-light text-center py-4"
}
const _hoisted_62 = {
  key: 2,
  class: "p-4 border rounded-3 bg-light mt-4"
}
const _hoisted_63 = { class: "mb-3" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-md-6 mb-3" }
const _hoisted_66 = { class: "col-md-6 mb-3" }
const _hoisted_67 = { class: "d-flex align-items-center gap-2" }
const _hoisted_68 = {
  key: 0,
  class: "material-symbols-outlined fs-24 text-primary"
}
const _hoisted_69 = { class: "col-md-6 mb-3" }
const _hoisted_70 = { class: "col-md-6 mb-3 d-flex align-items-end pb-2" }
const _hoisted_71 = { class: "form-check form-switch" }
const _hoisted_72 = { class: "col-12 mb-3" }
const _hoisted_73 = { class: "form-label fs-13 d-flex justify-content-between" }
const _hoisted_74 = { class: "mt-2 text-muted fw-bold" }
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["onClick", "disabled"]
const _hoisted_77 = { class: "d-flex justify-content-end gap-2 mt-2" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_80 = {
  key: 1,
  class: "alert alert-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Service' : 'Add Service',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _cache[20] || (_cache[20] = _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("button", {
              class: "nav-link active",
              id: "details-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#details-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "details-tab-pane",
              "aria-selected": "true"
            }, " Service Details ")
          ], -1)),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              class: "nav-link",
              id: "tutorials-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#tutorials-tab-pane",
              type: "button",
              role: "tab",
              "aria-controls": "tutorials-tab-pane",
              "aria-selected": "false",
              disabled: !_ctx.isEditing
            }, " Tutorials (Cara Kerja) ", 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", {
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Service Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.service_name) = $event)),
                    placeholder: "Enter service name",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.service_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Category", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.category) = $event)),
                    placeholder: "Enter category",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.category]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Base Price (Rp)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.base_price) = $event)),
                    placeholder: "0",
                    min: "0",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.base_price]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Base Discount (Rp)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.base_discount) = $event)),
                    placeholder: "0",
                    min: "0"
                  }, null, 512), [
                    [_vModelText, _ctx.form.base_discount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Unit", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.unit) = $event)),
                    placeholder: "e.g. per dokumen (s/d 50 hal.), per halaman"
                  }, null, 512), [
                    [_vModelText, _ctx.form.unit]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Material Icon", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.icon) = $event))
                    }, _cache[26] || (_cache[26] = [
                      _createStaticVNode("<option value=\"\">-- No Icon --</option><option value=\"plagiarism\">Plagiarism</option><option value=\"edit_document\">Edit Document</option><option value=\"auto_fix_high\">Auto Fix High</option><option value=\"menu_book\">Menu Book (Journal)</option><option value=\"translate\">Translate</option><option value=\"school\">School / Tutorial</option><option value=\"info\">Info</option><option value=\"check_circle\">Check Circle</option><option value=\"upload_file\">Upload File</option><option value=\"contact_support\">Contact Support</option><option value=\"inventory_2\">Package / Bundle</option><option value=\"description\">Description</option><option value=\"verified\">Verified</option><option value=\"star\">Star</option>", 15)
                    ]), 512), [
                      [_vModelSelect, _ctx.form.icon]
                    ]),
                    (_ctx.form.icon)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.form.icon), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Navigation Link", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.link) = $event)),
                    placeholder: "e.g. /cek-plagiarisme, /parafrase"
                  }, null, 512), [
                    [_vModelText, _ctx.form.link]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "featured",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.featured) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.featured]
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("label", {
                      class: "form-check-label text-dark fs-14 fw-medium",
                      for: "featured"
                    }, "Featured Service (Highlight on layout)", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Description", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.description) = $event)),
                    rows: "3",
                    placeholder: "Enter service description"
                  }, null, 512), [
                    [_vModelText, _ctx.form.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", null, "Features / Benefits (Bullet points)", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-outline-primary py-1 px-2",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addFeature && _ctx.addFeature(...args)))
                    }, _cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                      _createTextVNode("Add Feature ")
                    ]))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.features, (feat, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex mb-2 align-items-center gap-2"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.features[index]) = $event),
                        placeholder: "Enter benefit bullet point",
                        required: ""
                      }, null, 8, _hoisted_24), [
                        [_vModelText, _ctx.form.features[index]]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger p-2 lh-1",
                        onClick: ($event: any) => (_ctx.removeFeature(index)),
                        disabled: _ctx.form.features.length <= 1
                      }, _cache[33] || (_cache[33] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                      ]), 8, _hoisted_25)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "mb-0 fs-15 text-dark" }, "Price Tiers (Quantity-based Pricing)", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-outline-primary py-1 px-2",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addTier && _ctx.addTier(...args)))
                    }, _cache[34] || (_cache[34] = [
                      _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                      _createTextVNode("Add Tier ")
                    ]))
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "alert alert-info fs-13 py-2 mb-3" }, [
                    _createElementVNode("i", { class: "ri-information-line me-1" }),
                    _createTextVNode(" Define pricing tiers based on quantity/page count. If no tiers are added, the base price will be used. Leave \"Max Qty\" empty for open-ended tiers. ")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.price_tiers, (tier, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "p-3 border rounded-3 mb-3 bg-light"
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, "Tier #" + _toDisplayString(index + 1), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-danger py-0 px-2",
                          onClick: ($event: any) => (_ctx.removeTier(index))
                        }, _cache[36] || (_cache[36] = [
                          _createElementVNode("i", { class: "ri-delete-bin-line fs-14" }, null, -1)
                        ]), 8, _hoisted_30)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, [
                            _createTextVNode("Min Qty "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.min_qty) = $event),
                            required: "",
                            min: "1"
                          }, null, 8, _hoisted_33), [
                            [
                              _vModelText,
                              tier.min_qty,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Max Qty", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.max_qty) = $event),
                            placeholder: "∞"
                          }, null, 8, _hoisted_35), [
                            [
                              _vModelText,
                              tier.max_qty,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, [
                            _createTextVNode("Price (Rp) "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.price) = $event),
                            required: "",
                            min: "0",
                            step: "1000"
                          }, null, 8, _hoisted_37), [
                            [
                              _vModelText,
                              tier.price,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Discount (Rp)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.discount) = $event),
                            min: "0",
                            step: "1000"
                          }, null, 8, _hoisted_39), [
                            [
                              _vModelText,
                              tier.discount,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Label", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.label) = $event),
                            placeholder: "e.g. 1-10 Halaman"
                          }, null, 8, _hoisted_41), [
                            [_vModelText, tier.label]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Deadline", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((tier.deadline) = $event),
                            placeholder: "e.g. 3-5 Hari"
                          }, null, 8, _hoisted_43), [
                            [_vModelText, tier.deadline]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: 'tierActive'+index,
                              "onUpdate:modelValue": ($event: any) => ((tier.is_active) = $event)
                            }, null, 8, _hoisted_46), [
                              [_vModelCheckbox, tier.is_active]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label fs-12",
                              for: 'tierActive'+index
                            }, "Active", 8, _hoisted_47)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_RouterLink, {
                  to: "/services",
                  class: "btn btn-secondary fs-15 fw-medium"
                }, {
                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                    _createTextVNode("Cancel")
                  ])),
                  _: 1
                }),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary fs-15 fw-medium",
                  disabled: _ctx.loading
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Service' : 'Create Service'), 1)
                ], 8, _hoisted_49)
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_51, [
            (_ctx.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("h5", _hoisted_54, "Tutorials for " + _toDisplayString(_ctx.form.service_name), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openTutorialForm()))
                    }, _cache[45] || (_cache[45] = [
                      _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                      _createTextVNode(" Add Tutorial ")
                    ]))
                  ]),
                  (_ctx.tutorials.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("table", _hoisted_56, [
                          _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { scope: "col" }, "Order"),
                              _createElementVNode("th", { scope: "col" }, "Title"),
                              _createElementVNode("th", { scope: "col" }, "Steps"),
                              _createElementVNode("th", { scope: "col" }, "Status"),
                              _createElementVNode("th", {
                                scope: "col",
                                class: "text-end"
                              }, "Actions")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutorials, (tut) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: tut.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(tut.order), 1),
                                _createElementVNode("td", _hoisted_57, _toDisplayString(tut.title), 1),
                                _createElementVNode("td", null, _toDisplayString(tut.steps ? tut.steps.length : 0) + " steps", 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["badge", tut.is_active ? 'bg-success' : 'bg-danger'])
                                  }, _toDisplayString(tut.is_active ? 'Active' : 'Inactive'), 3)
                                ]),
                                _createElementVNode("td", _hoisted_58, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-primary py-0 px-2 me-2",
                                    onClick: ($event: any) => (_ctx.openTutorialForm(tut))
                                  }, " Edit ", 8, _hoisted_59),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-danger py-0 px-2",
                                    onClick: ($event: any) => (_ctx.deleteTutorial(tut.id))
                                  }, " Delete ", 8, _hoisted_60)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_61, " No tutorials added for this service yet. ")),
                  (_ctx.showTutorialForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("h6", _hoisted_63, _toDisplayString(_ctx.editingTutorialId ? 'Edit Tutorial' : 'Add New Tutorial'), 1),
                        _createElementVNode("form", {
                          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitTutorialForm && _ctx.submitTutorialForm(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label fs-13" }, "Title", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tutForm.title) = $event)),
                                required: "",
                                placeholder: "e.g. Cara Upload Dokumen"
                              }, null, 512), [
                                [_vModelText, _ctx.tutForm.title]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label fs-13" }, "Material Icon", -1)),
                              _createElementVNode("div", _hoisted_67, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tutForm.icon) = $event))
                                }, _cache[48] || (_cache[48] = [
                                  _createStaticVNode("<option value=\"\">-- No Icon --</option><option value=\"plagiarism\">Plagiarism</option><option value=\"edit_document\">Edit Document</option><option value=\"auto_fix_high\">Auto Fix High</option><option value=\"menu_book\">Menu Book (Journal)</option><option value=\"translate\">Translate</option><option value=\"school\">School / Tutorial</option><option value=\"info\">Info</option><option value=\"check_circle\">Check Circle</option><option value=\"upload_file\">Upload File</option><option value=\"contact_support\">Contact Support</option><option value=\"inventory_2\">Package / Bundle</option><option value=\"description\">Description</option><option value=\"verified\">Verified</option><option value=\"star\">Star</option>", 15)
                                ]), 512), [
                                  [_vModelSelect, _ctx.tutForm.icon]
                                ]),
                                (_ctx.tutForm.icon)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.tutForm.icon), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _cache[50] || (_cache[50] = _createElementVNode("label", { class: "form-label fs-13" }, "Display Order", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tutForm.order) = $event)),
                                min: "1",
                                required: ""
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.tutForm.order,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", _hoisted_71, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: "tutActive",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tutForm.is_active) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.tutForm.is_active]
                                ]),
                                _cache[51] || (_cache[51] = _createElementVNode("label", {
                                  class: "form-check-label fs-13",
                                  for: "tutActive"
                                }, "Active", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("label", _hoisted_73, [
                                _cache[53] || (_cache[53] = _createElementVNode("span", null, "Tutorial Steps", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-outline-primary py-0 px-2",
                                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addTutStep && _ctx.addTutStep(...args)))
                                }, _cache[52] || (_cache[52] = [
                                  _createElementVNode("i", { class: "ri-add-line" }, null, -1),
                                  _createTextVNode(" Add Step ")
                                ]))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutForm.steps, (step, sIdx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: sIdx,
                                  class: "d-flex mb-2 gap-2"
                                }, [
                                  _createElementVNode("span", _hoisted_74, _toDisplayString(sIdx + 1) + ".", 1),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.tutForm.steps[sIdx]) = $event),
                                    required: "",
                                    placeholder: "Enter step instruction"
                                  }, null, 8, _hoisted_75), [
                                    [_vModelText, _ctx.tutForm.steps[sIdx]]
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-outline-danger p-2",
                                    onClick: ($event: any) => (_ctx.removeTutStep(sIdx)),
                                    disabled: _ctx.tutForm.steps.length <= 1
                                  }, _cache[54] || (_cache[54] = [
                                    _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                                  ]), 8, _hoisted_76)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-secondary",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showTutorialForm = false))
                            }, "Cancel"),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-sm btn-primary",
                              disabled: _ctx.tutLoading
                            }, [
                              (_ctx.tutLoading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79))
                                : _createCommentVNode("", true),
                              _cache[55] || (_cache[55] = _createTextVNode(" Save Tutorial "))
                            ], 8, _hoisted_78)
                          ])
                        ], 32)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_80, " Please save the service details first before adding tutorials. "))
          ])
        ])
      ])
    ])
  ]))
}